import InfoIcon from '@mui/icons-material/Info';
import { Tooltip } from '@mui/material';
import React from 'react';
import useTheme from '@/theme/useTheme';

const InfoTooltip = ({ text }: { text: string | React.ReactChild }) => {
  const { theme } = useTheme();

  return (
    <Tooltip title={text} placement="right-start">
      <InfoIcon
        fontSize="small"
        sx={{
          marginLeft: theme.spacing(0.5),
          color: theme.palette.grey[400],
          cursor: 'pointer',
        }}
      ></InfoIcon>
    </Tooltip>
  );
};

export default InfoTooltip;
